//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalBase from '@/components/Shared/ModalBase.vue'
export default {
  components: {
    ModalBase,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    canCancel: {
      type: [Boolean, Array],
      default: false,
    },
    width: {
      type: [Number],
      default: 640,
    },
  },
  data() {
    return {
      isShow: this.value,
    }
  },
  watch: {
    value(newValue) {
      this.isShow = newValue
    },
    isShow(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    onToggle() {
      this.isShow = !this.isShow
    },
  },
}
